import transactionAdUnit from './transactionAdUnit';

export default transactionAdUnit;
